<template>
  <div class="advantage-container">
    <div class="advantage-title">
      <span class="main-title wow fadeInUp">服务优势</span>
      <span class="sub-title wow fadeInUp">ADVANTAGE</span>
    </div>
    <div class="advantage-card-container">
      <div class="card-one">
        <div class="advantage-card wow fadeInUp"></div>
      </div>
      <div class="card-two">
        <div class="advantage-card wow fadeInUp" data-wow-delay="0.1s">
          <div class="card-logo">
            <img src="@/assets/images/icon-maintain.png" alt="" />
          </div>
          <div class="card-title">
            <span>终身产品维护</span>
          </div>
        </div>
      </div>
      <div class="card-three">
        <div class="advantage-card wow fadeInUp" data-wow-delay="0.2s">
          <div class="card-logo">
            <img src="@/assets/images/icon-team.png" alt="" />
          </div>
          <div class="card-title">
            <span>终身产品维护</span>
          </div>
        </div>
      </div>
      <div class="card-four">
        <div class="advantage-card wow fadeInUp" data-wow-delay="0.3s">
          <div class="card-logo">
            <img src="@/assets/images/icon-clock.png" alt="" />
          </div>
          <div class="card-title">
            <span>终身产品维护</span>
          </div>
        </div>
      </div>
      <div class="card-five">
        <div class="advantage-card wow fadeInUp" data-wow-delay="0.4s">
          <div class="card-logo">
            <img src="@/assets/images/icon-tryout.png" alt="" />
          </div>
          <div class="card-title">
            <span>终身产品维护</span>
          </div>
        </div>
      </div>
      <div class="card-six">
        <div class="advantage-card wow fadeInUp" data-wow-delay="0.5s">
          <div class="card-logo">
            <img src="@/assets/images/icon-customize.png" alt="" />
          </div>
          <div class="card-title">
            <span>终身产品维护</span>
          </div>
        </div>
      </div>
      <div class="card-seven">
        <div class="advantage-card wow fadeInUp"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.advantage-container {
  width: 100%;
  height: 500px;
  background-image: linear-gradient(180deg, #ffffff 0%, #f9fafc 100%);
  overflow-y: hidden;
  .advantage-title {
    display: flex;
    flex-direction: column;
    margin-top: 80px;
    .main-title {
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      color: #222222;
      text-align: center;
    }
    .sub-title {
      font-family: PingFangSC-Light;
      font-size: 24px;
      color: #c4cad6;
      text-align: center;
    }
  }
  .advantage-card-container {
    // max-width: 1400px;
    height: 350px;
    display: flex;
    justify-content: center;
    // margin: 0 auto;
    margin-top: 50px;
    position: relative;
    .advantage-card {
      // position: absolute;
      width: 200px;
      min-width: 200px;
      height: 350px;
      background-image: linear-gradient(180deg, #ffffff 0%, #f4f5fb 100%);
      border: 1px solid #e9eef5;
      box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .card-logo {
        margin: 52px 0 20px 0;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .card-title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #3c3d3f;
      }
    }
    .card-one {
      transform: translate(160px, 200px);
    }
    .card-two {
      z-index: 8;
      transform: translate(60px, 100px);
    }
    .card-three {
      z-index: 9;
      transform: translate(30px, 50px);
    }
    .card-four {
      z-index: 10;
    }
    .card-five {
      z-index: 9;
      transform: translate(-30px, 50px);
    }
    .card-six {
      z-index: 8;
      transform: translate(-60px, 100px);
    }
    .card-seven {
      // left: 1040px;
      // bottom: -200px;
      // z-index: 7;
      transform: translate(-160px, 200px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/advantage.vue